import { Descriptions } from "antd";

import type { ReactNode } from "react";
import type { ItfTaxpayer } from "types/taxpayers";

export function TaxpayerPersonalInfo(props: { taxpayer: ItfTaxpayer; extraOnDescriptions?: ReactNode }): JSX.Element {
  const { taxpayer, extraOnDescriptions = null } = props;

  return (
    <Descriptions
      bordered
      size="small"
      layout="vertical"
      title="Datos personales del contribuyente"
      extra={extraOnDescriptions}
    >
      <Descriptions.Item label="RFC">{taxpayer.rfc}</Descriptions.Item>

      <Descriptions.Item label="Nombre">{taxpayer.name}</Descriptions.Item>

      <Descriptions.Item label="SKID">{taxpayer.skid}</Descriptions.Item>

      <Descriptions.Item label="Nacionalidad">{taxpayer?.is_foreign ? "EXTRANJERA" : "MEXICANA"}</Descriptions.Item>

      <Descriptions.Item label="Estado">{taxpayer.state}</Descriptions.Item>

      <Descriptions.Item label="Dirección">{taxpayer.address}</Descriptions.Item>

      <Descriptions.Item label="Correo">{taxpayer.email}</Descriptions.Item>

      <Descriptions.Item label="Teléfono">{taxpayer.phone_number}</Descriptions.Item>

      <Descriptions.Item label="Extranjero">{taxpayer?.is_foreign ? "SI" : "NO"}</Descriptions.Item>
    </Descriptions>
  );
}
